import { QuestionPlanBase } from "./base/root";
import { QuestionPlanEmail } from "./email/root";
import { QuestionPlanPreQuestions } from "./pre-questions/root";

import type { PlanI18nCategoriesAndManagerStore } from "../store/categories";

type Props = {
	planI18nCategoriesAndManagerStore: Omit<
		PlanI18nCategoriesAndManagerStore,
		"categoryManagerStore" | "categoryStoreArray"
	>;
	hotelID: string;
	planID: string;
	hotelEmailAddress: string;
};

export const PlanI18nFormMain = ({ planI18nCategoriesAndManagerStore, hotelID, planID, hotelEmailAddress }: Props) => {
	const { base, email, preQuestions } = planI18nCategoriesAndManagerStore;

	return (
		<>
			<QuestionPlanBase base={base} />
			<QuestionPlanPreQuestions preQuestions={preQuestions} />
			<QuestionPlanEmail email={email} hotelID={hotelID} planID={planID} hotelEmailAddress={hotelEmailAddress} />
		</>
	);
};

PlanI18nFormMain.displayName = "PlanI18nFormMain";
